document.addEventListener('DOMContentLoaded', function () {
    function updateQtyInput(qtyInput, clicked) {
        // Change the value after a short delay
        var val = parseFloat(qtyInput.value);
        var max = qtyInput.getAttribute('max') ? parseFloat(qtyInput.getAttribute('max')) : 1000000;
        var min = qtyInput.getAttribute('min') ? parseFloat(qtyInput.getAttribute('min')) : 1;
        var step = qtyInput.getAttribute('step') ? parseFloat(qtyInput.getAttribute('step')) : 1;
        var newValue = val;

        // Change the value if plus or minus
        if (clicked.classList.contains('plus')) {
            if (max && (max <= val)) {
                newValue = max;
            } else {
                newValue = val + step;
            }
        } else {
            if (min && (min >= val)) {
                newValue = min;
            } else if (val > 1) {
                newValue = val - step;
            }
        }

        qtyInput.value = newValue;

        if (clicked.closest('.qty-lef-wrapper')) {
            var quantityData = clicked.closest('.qty-lef-wrapper').nextElementSibling;
            quantityData.setAttribute('data-quantity', newValue);
        }

        const updateCartButton = document.querySelector('button[name="update_cart"]');
        if (updateCartButton) {
            updateCartButton.disabled = false; // Remove the disabled attribute
        }

        setTimeout(() => {
            qtyInput.dispatchEvent(new Event('change'));
        }, 300);
    }

    if (document.body.classList.contains('lef-webshop')) {
        // Quantity button event listener for '.quantity'
        document.body.addEventListener('click', function (e) {
            if (e.target.matches('button.plus, button.minus')) {
                // Get current quantity values
                var qty = e.target.closest('.quantity').querySelector('.qty');
                updateQtyInput(qty, e.target);
            }
        });

        if (document.querySelector('.filter-list')) {
            toggleFilter();
            primaryFilterClick();
        }
    }

    if (document.querySelector('.checkout-coupon-overlay')) {
        document.body.addEventListener('click', function (e) {
            // Check if the clicked element matches the selector
            if (e.target.matches('.checkout-coupon-overlay button[name="apply_coupon"]')) {
                e.preventDefault();
        
                // Get the coupon code from the input field
                var couponCodeInput = e.target.parentElement.querySelector('input[name="coupon_code"]');
                var coupon_code = couponCodeInput.value;
        
                // Find the corresponding input and button in the WooCommerce coupon login section
                var woocommerceCouponInput = document.querySelector('.woocommerce-coupon-login .woocommerce-form-coupon-holder input[name="coupon_code"]');
                if (woocommerceCouponInput) {
                    woocommerceCouponInput.value = coupon_code;
                }
        
                var woocommerceApplyButton = document.querySelector('.woocommerce-coupon-login .woocommerce-form-coupon-holder button[name="apply_coupon"]');
                if (woocommerceApplyButton) {
                    woocommerceApplyButton.click();
                }
            }
        });
    }

    setTimeout(function() {
        if (document.querySelectorAll('.show-password-input')) {
            var password_inputs = document.querySelectorAll('.show-password-input');
    
            password_inputs.forEach(function (element) {
                element.innerHTML = '<i class="icon icon-eye" style="margin-right: unset;"></i>';
            });
        }
    }, 50);
    
});

function toggleFilter() {
    var elements = document.querySelectorAll('.filter-holder .filter-list .open-switcher, .filter-holder .filter-list .filter-title');
    var action = "click";

    elements.forEach(function (element) {
        element.addEventListener(action, function () {
            var parent = element.parentElement;

            if (parent.classList.contains('filter-closed')) {
                parent.classList.remove('filter-closed');
                var filterItems = parent.querySelector('.filter-items');
                if (filterItems) {
                    filterItems.style.display = 'block';
                    setTimeout(function () {
                        filterItems.style.transition = 'height 300ms';
                    }, 0);
                }
            } else {
                parent.classList.add('filter-closed');
                var filterItems = parent.querySelector('.filter-items');
                if (filterItems) {
                    filterItems.style.display = 'none';
                }
            }
        });
    });
}

function primaryFilterClick() {
    var elements = document.querySelectorAll('.primary-filters .primary-filter');
    var action = "click";

    elements.forEach(function (element) {
        element.addEventListener(action, function () {
            var category = element.getAttribute('data-filter-category');
            var filterItem = document.querySelector('.all-filters-holder .filter-item input#' + category);

            if (filterItem) {
                filterItem.click();
            }
        });
    });
}
